export default {
      id: "badge-usage",
      viewBox: "0 0 105 130",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#badge-usage",
      toString: function () {
        return this.url;
      }
    }